import { render, staticRenderFns } from "./FileComponent.vue?vue&type=template&id=2c3c4e82&"
import script from "./FileComponent.vue?vue&type=script&lang=js&"
export * from "./FileComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports